<div
  class="sp-width__full sp-height__full sp-page__with-navbar"
  [ngClass]="getNavbarClass()">
  <app-navbar
    class="sp-hidden__before-lg"
    [current_nav_item]="current_nav_item"
    [navbar_status]="navbar_status"
    (status_change)="onNavbarStatusChange($event)"></app-navbar>

  <div class="sp-position__relative">
    <app-toolbar
      [current_nav_item]="current_nav_item"
      [width_class]="getToolbarWidthClass()"></app-toolbar>

    <div
      class="sp-page__with-absolute-toolbar sp-grid__gap sp-padding__x2"
      [ngClass]="areFiltersSet() ? 'sp-stores__grid-with-filters' : 'sp-stores__grid'">
      <app-pending-invitations-header
        (refresh)="onRefresh()"
        (filter)="onFilter()"></app-pending-invitations-header>

      <div class="sp-margin__top-x2">
        <app-pending-invitations-filters
          *ngIf="areFiltersSet()"
          [filters]="filters"
          (filter_clear)="onFilterClear($event)"></app-pending-invitations-filters>
      </div>

      <div class="sp-margin__top-x2">
        <app-pending-invitations-data (refresh)="onRefresh()"></app-pending-invitations-data>
      </div>
    </div>
  </div>
</div>
